import { Skeleton } from "antd";

type params = {
  children: React.ReactNode
  loading: boolean
  arrayItems: number,
  className: string
  heightClass: string
  mtClass?: string
}
const SkeletonGeneralCard: React.FC<params> = ({children,loading, arrayItems,className, heightClass,mtClass}) => {
  return (
    <div className={mtClass ? `${mtClass}` : `mt-10`}>
      {loading ? 
        <>
      <div className={className}>
        {Array.from(Array(arrayItems).keys()).map(i => (
          <div className={`w-full skeleton-h-full ${heightClass}`} key={i}>
            <Skeleton.Button active block={true}  size="large" /> 
          </div>
        ))}
        </div>  
        </>
      : 
      <>
        {children}
      </>
      }
    
    </div>

  );
};
export default SkeletonGeneralCard;
